import { gql } from 'graphql-request';

export const siteContextFieldsQuery = gql`
    query getSiteSummaryFields($projectId: String!) {
        siteSummary {
            getSiteSummaryFields(siteId: $projectId) {
                activity
                stage
                subscription
                objectives
                area
                country
                ecologicalContext
            }
        }
    }
`;

export const setActivityMutation = gql`
    mutation setActivity($projectId: String!, $activity: String!) {
        siteSummary {
            setActivity(siteId: $projectId, activity: $activity)
        }
    }
`;

export const setStageMutation = gql`
    mutation setStage($projectId: String!, $stage: String!) {
        siteSummary {
            setStage(siteId: $projectId, stage: $stage)
        }
    }
`;

export const setObjectivesMutation = gql`
    mutation setObjectives($projectId: String!, $objectives: String!) {
        siteSummary {
            setObjectives(siteId: $projectId, objectives: $objectives)
        }
    }
`;

export const setAreaMutation = gql`
    mutation setArea($projectId: String!, $area: Float!) {
        siteSummary {
            setArea(siteId: $projectId, area: $area)
        }
    }
`;

export const setEcologicalContextMutation = gql`
    mutation setEcologicalContext($projectId: String!, $ecologicalContext: String!) {
        siteSummary {
            setEcologicalContext(siteId: $projectId, ecologicalContext: $ecologicalContext)
        }
    }
`;

export type SiteContextFields = {
    activity?: string | null;
    stage?: string | null;
    subscription?: string | null;
    objectives?: string | null;
    area?: number | null;
    country?: string | null;
    ecologicalContext?: string | null;
};

export type SiteContextFieldsQueryResult = {
    siteSummary: {
        getSiteSummaryFields: SiteContextFields;
    };
};
